import { Button } from "@mui/material";
import { SamlSettings } from "../../../models/Interfaces";

interface SsoFormProps {
    url: string;
}

export default function SsoForm ({url}: SsoFormProps) {

    return (
        <div style={{width: "300px"}}>
            <h1 style={{fontSize: "30px"}}>Sign in</h1>
            <p>Your account is configured to connect using Microsoft, click the button below to sign in.</p>
            <br/>
            <Button
                className="btn btn-md"
                color="info"
                variant="contained"
                style={{textTransform: "none"}}
                href={url}>
                Sign in with
                <img alt="M" height="14" src="/images/microsoft.png" />
            </Button>
        </div>
    )
}